import { client2 } from "../utils/axios";

export function signIn() {
  return client2.get("/users/me", {}).then((response) => {
    return response.data;
  });
}
